import FormInviteCooperatorsPage from '@/views/forms/FormInviteCooperatorsPage'
import FormLayout from '@/views/layouts/FormLayout'

export default function Cooperators() {
  return (
    <FormLayout>
      <FormInviteCooperatorsPage />
    </FormLayout>
  )
}
